import learningApi from '@src/services/api/learning/index'

export default learningApi.defineApi([
  // 修了証WEB表示（公開API・認証不要）
  {
    name: 'getCertificateIssue',
    method: 'get',
    url: '/issue/:token'
  }
])
